export const truncateToThreeDecimals = (value) => {
  let num = parseFloat(value); // Converti la stringa in numero
  if (isNaN(num)) return new Error('Errore: input non valido');
  return Math.trunc(num * 1000) / 1000; // Tronca a 3 cifre decimali
};
